import CacheCleaner from "./CacheCleaner"
import CacheManager from "../CacheManager"

export default class HorseCleaner extends CacheCleaner {

	async onMutation(horse_ids, columns) {
		await CacheManager.inst().onObjectsMutation('horse', horse_ids, columns)
	}
}
